import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const TechnoEcho = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [modalData, setModalData] = useState({
        id: null,
        information: "",
        techno_echo_file: null,
        techno_echo_name: "",
        old_techno_echo: null,
    });

    const [techno_echo, setTechnoEcho] = useState([]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, [school_slug]);

    const fetchContent = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/life_at_tigps/get_techno_echo/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                setTechnoEcho(res.data.data || []);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- Handler --------------- */

    const handleEdit = (item) => {
        setIsEdit(true);
        setModalData({
            id: item.id,
            information: item.information || "",
            techno_echo_file: null,
            old_techno_echo: item.file_name,
        });
        setShowModal(true);
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setModalData(prev => ({
                ...prev,
                techno_echo_file: file,
                techno_echo_name: file.name,   // ✅ auto image name
            }));
        }
    };


    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this Techno Echo?")) return;
        const formData = new FormData();
        formData.append("id", id);
        try {
            const res = await axios.post(
                `${baseAPIUrl}admin/life_at_tigps/delete_techno_echo`,
                formData,
                { withCredentials: true }
            );

            // Remove from UI instantly
            if (res.data.status === 1) {
                setTechnoEcho(prev => prev.filter(img => img.id !== id));
            } else {
                alert(res.data.message || "Delete failed");
            }
        } catch (err) {
            console.error(err.response);
            alert(err.response?.data?.message || "Failed to delete Techno Echo");
        }
    };

    const handleSave = async () => {
        const formData = new FormData();

        formData.append("school_slug", school_slug);
        formData.append("techno_echo_name", modalData.techno_echo_name);
        formData.append("information", modalData.information);

        if (modalData.techno_echo_file) {
            formData.append("techno_echo_file", modalData.techno_echo_file);
        }

        if (isEdit) {
            formData.append("id", modalData.id);
            formData.append("old_techno_echo", modalData.old_techno_echo);
        }

        try {
            const url = isEdit
                ? `${baseAPIUrl}admin/life_at_tigps/update_techno_echo`
                : `${baseAPIUrl}admin/life_at_tigps/add_techno_echo`;

            const res = await axios.post(url, formData, {
                withCredentials: true,
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (res.data && res.data.status === 1) {
                setShowModal(false);
                fetchContent(); // reload table
            } else {
                const errMsg = res.data?.message || res.data?.msg || "Failed to save file.";
                alert(errMsg);
                if (errMsg.toLowerCase().includes("unauthorized") || errMsg.toLowerCase().includes("please login")) {
                    localStorage.removeItem("isLoggedIn");
                    localStorage.removeItem("school_slugs");
                    window.location.href = "/admin";
                }
            }
        } catch (err) {
            console.error(err);
            const errMsg = err.response?.data?.message || err.response?.data?.msg || "Failed to save file.";
            alert(errMsg);
            if (errMsg.toLowerCase().includes("unauthorized") || errMsg.toLowerCase().includes("please login")) {
                localStorage.removeItem("isLoggedIn");
                localStorage.removeItem("school_slugs");
                window.location.href = "/admin";
            }
        }
    };



    /* ---------------- Submit ---------------- */


    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Techno Echo</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Life at TIGPS</li>
                                <li class="breadcrumb-item active">Techno Echo</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4>Techno Echo list</h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button className="btn btn-primary" onClick={() => {
                                                setIsEdit(false);
                                                setModalData({
                                                    id: null,
                                                    techno_echo_name: "",
                                                    information: "",
                                                    techno_echo_file: null,
                                                    old_techno_echo: null,
                                                });
                                                setShowModal(true);
                                            }}>Add Techno Echo</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-hover text-nowrap">
                                        <thead className="thead-light">
                                            <tr>
                                                <th style={{ width: "80px" }}>#</th>
                                                <th>File</th>
                                                <th>Document / Information</th>
                                                <th style={{ width: "150px" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {techno_echo.length > 0 ? (
                                                techno_echo.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>

                                                        <td>
                                                            <a
                                                                href={`${baseAPIUrl}assets/images/techno_echo/${item.file_name}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="d-flex align-items-center text-decoration-none"
                                                            >
                                                                <i
                                                                    className="fas fa-file-pdf fa-2x text-danger mr-2"
                                                                    title="View PDF"
                                                                ></i>
                                                                <span className="text-primary">
                                                                    {item.file_name}
                                                                </span>
                                                            </a>
                                                        </td>
                                                        <td style={{ maxWidth: "300px", whiteSpace: "normal" }}>
                                                            {item.information ? item.information : <span className="text-muted">—</span>}
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-info mr-2"
                                                                onClick={() => handleEdit(item)}
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </button>

                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleDelete(item.id)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No File found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "flex",
                        alignItems: "center",      // ✅ vertical center
                        justifyContent: "center",  // ✅ horizontal center
                        backgroundColor: "rgba(0,0,0,0.5)",
                        inset: 0,
                        zIndex: 1050,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: "80%", margin: 0, width: "100%" }}>
                        <div className="modal-content" style={{ maxWidth: "80%", margin: "0 auto", width: "100%" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {isEdit ? "Edit Image" : "Add Image"}
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">

                                {/* Document / Information */}
                                <div className="form-group">
                                    <label>Document / Information </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        rows="3"
                                        value={modalData.information}
                                        placeholder="Document name"
                                        onChange={(e) =>
                                            setModalData({ ...modalData, information: e.target.value })
                                        }
                                    />
                                </div>

                                {/* File Upload */}
                                <div className="form-group">
                                    <label>File</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={handleImageChange}
                                    />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button className="btn btn-success" onClick={handleSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div >
    )
}
export default TechnoEcho;